export default "skymp5-front/9c26de6addf1f2d8b12b6002ae854b95.svg";